/**
 * errorReporting — Sentry integration wrapper.
 */
import * as Sentry from '@sentry/react-native';

let initialized = false;

export function initErrorReporting() {
  const dsn = process.env.EXPO_PUBLIC_SENTRY_DSN;
  if (!dsn) {
    if (__DEV__) console.log('[ErrorReporting] No EXPO_PUBLIC_SENTRY_DSN set, skipping Sentry init');
    return;
  }

  Sentry.init({
    dsn,
    sampleRate: 1.0,
    tracesSampleRate: 0.1,
    enabled: !__DEV__,
    beforeSend(event) {
      // Scrub email addresses from all string fields
      const scrubEmail = (str: string) =>
        str.replace(/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g, '[email]');

      // Scrub from message
      if (event.message) {
        event.message = scrubEmail(event.message);
      }

      // Scrub from exception values
      if (event.exception?.values) {
        event.exception.values = event.exception.values.map(ex => ({
          ...ex,
          value: ex.value ? scrubEmail(ex.value) : ex.value,
        }));
      }

      // Remove user email from Sentry user context
      if (event.user) {
        delete event.user.email;
        delete event.user.username;
      }

      return event;
    },
  });
  initialized = true;
}

export function captureError(error: unknown, context?: Record<string, unknown>) {
  if (__DEV__) {
    console.error('[ErrorReporting] captureError:', error, context);
  }
  if (!initialized) return;
  if (context) {
    Sentry.withScope((scope) => {
      scope.setExtras(context);
      Sentry.captureException(error);
    });
  } else {
    Sentry.captureException(error);
  }
}

export function setUser(userId: string, email?: string) {
  if (!initialized) return;
  Sentry.setUser({ id: userId, ...(email ? { email } : {}) });
}
